<template>
  <base-material-design-icon
    icon="camera"
    @click="takePhoto"
    v-if="isButtonVisible"/>
</template>

<script>
import html2canvas from 'html2canvas'

/**
 * is used to make screenshots of pointed component
 * used html2canvas library {@link https://html2canvas.hertzen.com/getting-started}
 */
export default {
  name: 'BaseScreenshot',
  props: {
    /* id of wrapper screenshoted content */
    id: {
      type: String,
      required: true
    },
    /* screenshot name */
    name: {
      type: String,
      default: 'overlay'
    }
  },
  data () {
    return {
      // flag == true when screenshot is taking
      isPhotoTaking: false
    }
  },
  methods:
    {
      /**
       * method makes screenshot of component with specific id
       */
      takePhoto () {
        this.isPhotoTaking = true
        this.$emit('screenshot', this.isPhotoTaking)
        this.$nextTick().then(() => {
          const element = document.getElementById(this.id)
          if (!element) {
            throw new Error(`Can't find an element with id: ${this.id}`)
          }
          this.isPhotoTaking = false
          this.$emit('screenshot', this.isPhotoTaking)
          const elementClone = element.cloneNode(true)
          return elementClone
        }).then(element => {
          element.style.position = 'absolute'
          element.style.left = '1000vw'
          const body = document.querySelector('body')
          body.appendChild(element)
          html2canvas(element, { logging: false }).then(canvas => {
            const url = canvas.toDataURL()
            const link = document.createElement('a')
            link.download = `${this.name}.png`
            link.href = url
            link.click()
            body.removeChild(element)
          })
        }).catch(err => {
          console.error(err)
        })
      }
    },
  computed: {
    isButtonVisible () {
      return !this.isPhotoTaking
    }
  }

}
</script>

<style scoped lang="scss">

</style>
